import { formatDocumentToApiDocument } from './document-to-api-document';

import type {
  ApplicationData,
  Document,
  PartnerApplicationContext,
} from '../../model';

export function formatBusinessDocuments(
  data: ApplicationData,
  values: Partial<PartnerApplicationContext>['businessDocuments']
): ApplicationData {
  if (!values) return data;

  const docs: Document[] = [];

  values.BUSINESS_PERMIT?.forEach((doc) => {
    docs.push(formatDocumentToApiDocument(doc, 'BUSINESS_PERMIT'));
  });

  values.BIR_CERTIFICATE_OR_FORM2303?.forEach((doc) => {
    docs.push(formatDocumentToApiDocument(doc, 'BIR_CERTIFICATE_OR_FORM2303'));
  });

  values.DTI_CERTIFICATE?.forEach((doc) => {
    docs.push(formatDocumentToApiDocument(doc, 'DTI_CERTIFICATE'));
  });

  values.OTHER?.forEach((doc) => {
    docs.push(formatDocumentToApiDocument(doc, 'OTHER'));
  });

  return { ...data, businessDocuments: docs };
}
